import './css/base.css';

import React from 'react';
import ReactDOM from 'react-dom';

import ItemFilter from './ItemFilter.jsx';
import FilterOptions from './FilterOptions.jsx';

import LetterSelect from './LetterSelect.jsx';
import LetterDetails from './LetterDetails.jsx';

import { sortByKey } from './functions.js';
import { sortQualifications } from './functions.js';

// receive superclasses
// group by letter, and list the individual items
// limited interactivity - only scrolling by anchor tags
// no state changes
var App = React.createClass({

    getInitialState: function() {

        var savedFilters = localStorage.getItem('subjectFilter');

        if ( savedFilters != null ) {
            var parsedSavedFilters = JSON.parse(savedFilters);
            return({
                // baseQuery: 'superclasses.json',
                // baseQuery: 'http://sandbox.sqa.org.uk/sqa_newmetadata/searchsuperclass',
                baseQuery: 'http://www.sqa.org.uk/sqa_metadata/searchsuperclass',
                data : [],
                filteredData : [],
                filterText : parsedSavedFilters.filterText != null ? parsedSavedFilters.filterText : '',
                SCQF : parsedSavedFilters.SCQF != null ? parsedSavedFilters.SCQF : [],
                QCF : parsedSavedFilters.QCF != null ? parsedSavedFilters.QCF : [],
                superclasses: parsedSavedFilters.superclasses != null ? parsedSavedFilters.superclasses : 10000,
                count : parsedSavedFilters.count != null ? parsedSavedFilters.count : 10000
            })
        }
        else {
            return({
                // baseQuery: 'superclasses.json',
                // baseQuery: 'http://sandbox.sqa.org.uk/sqa_newmetadata/searchsuperclass',
                baseQuery: 'http://www.sqa.org.uk/sqa_metadata/searchsuperclass',
                data : [],
                filteredData : [],
                filterText : '',
                SCQF : [],
                QCF : [],
                superclasses: 10000,
                count : 10000
            })
        }

    },

    componentDidMount: function() {

        var component = this;

        this.populate();

    },

    populate: function(){

        var component = this;

        var Query = this.state.baseQuery;
        //console.log('sample json for superclasses: ' + Query);

        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (xhttp.readyState == 4 && xhttp.status == 200) {

                var response = JSON.parse(xhttp.responseText);

                var data = [{"letter":"A","items":[]},{"letter":"B","items":[]},{"letter":"C","items":[]},{"letter":"D","items":[]},{"letter":"E","items":[]},{"letter":"F","items":[]},{"letter":"G","items":[]},{"letter":"H","items":[]},{"letter":"I","items":[]},{"letter":"J","items":[]},{"letter":"K","items":[]},{"letter":"L","items":[]},{"letter":"M","items":[]},{"letter":"N","items":[]},{"letter":"O","items":[]},{"letter":"P","items":[]},{"letter":"Q","items":[]},{"letter":"R","items":[]},{"letter":"S","items":[]},{"letter":"T","items":[]},{"letter":"U","items":[]},{"letter":"V","items":[]},{"letter":"W","items":[]},{"letter":"X","items":[]},{"letter":"Y","items":[]},{"letter":"Z","items":[]}];
                var letters = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];

                var sortedResponse = sortByKey( response, 'superclassClassification');

                // loop over JSON response to populate data structure
                for (var y = 0; y < sortedResponse.length; y++ ) {

                    var superClass = sortedResponse[y].superclassClassification;
                    var superClassInitial = superClass.charAt(0);

                    var letterPos = letters.indexOf( superClassInitial );
                    data[letterPos].items.push({
                        id : sortedResponse[y].superclassId,
                        title : sortedResponse[y].superclassClassification,
                        qualifications : sortQualifications(sortedResponse[y].qualifications)
                    });

                }

                // update component state
                component.setState({
                    data : data,
                    filteredData : data
                });

                var savedFilters = localStorage.getItem('subjectFilter');

                // if no filters in local storage, then populate it with nothing
                if ( savedFilters != null ) {
                    component.filter();
                }

            }
        };
        xhttp.open( 'GET', Query, true);
        xhttp.send();

    },

    render: function() {

        var component = this;

        const letters = this.state.filteredData.map( ( letter ) => {

            return (
                <LetterSelect
                    letter = { letter.letter }
                    active = { letter.items.length > 0 ? true : false }
                />
            );


        });

        const letterDetails = this.state.filteredData.map( ( letter ) => {

            if ( letter.items.length > 0 ) {

                return (
                    <LetterDetails
                        letter = { letter.letter }
                        items = { letter.items }
                        superclasses = { this.state.superclasses }
                        count = { this.state.count }
                        filteredText = { component.state.filterText }
                    />
                );

            }

        });

        if ( this.state.data.length > 0 ) {

            return (
                <div id="subject--search">
                    <ItemFilter
                        filterText={this.state.filterText}
                        onUserInput={this.handleUserInput}
                    />
                    <FilterOptions
                        onOptionChange={this.handleOptionChange}
                        QCFLevels={this.state.QCF}
                        SCQFLevels={this.state.SCQF}
                    />
                    <ul className="letter--select flex flex__between list__presentational">
                        { letters }
                    </ul>
                    <div className="letter--details">
                        { letterDetails }
                    </div>
                </div>
            );

        }

        else {

            return (
                <div id="subject--search">
                    <ItemFilter
                        filterText={this.state.filterText}
                        onUserInput={this.handleUserInput}
                    />
                    <FilterOptions
                        onOptionChange={this.handleOptionChange}
                        QCFLevels={this.state.QCF}
                        SCQFLevels={this.state.SCQF}
                    />
                    <div className="subject--search--loading">
                        <img src="/sqa/superclasses/ajax-loader.gif" />
                    </div>
                </div>
            );

        }

    },

    handleUserInput: function(filterText) {

        var component = this;
        var executed = false;

        var data = {
            filterText: filterText,
            QCF : component.state.QCF,
            SCQF : component.state.SCQF
        };

        //console.log('filtering');
        localStorage.setItem('subjectFilter', JSON.stringify ( data ) );

        component.setState({
            filterText: filterText
        }, function(){
            component.filter();
        });

    },

    handleOptionChange : function(filtered){

        var component = this;

        if ( filtered == 'reset' ) {

            var data = {
                filterText: component.state.filterText,
                QCF : [],
                SCQF : []
            };

            localStorage.setItem('subjectFilter', JSON.stringify ( data ) );

            component.setState({
                QCF : [],
                SCQF : []
            }, function(){
                component.filter();
            });

        }

        else if ( filtered == 'clear' ) {

            var data = {
                filterText: component.state.filterText,
                QCF : [1,2,3,4,5,6,7,8],
                SCQF : [1,2,3,4,5,6,7,8,9,10,11,12]
            };

            localStorage.setItem('subjectFilter', JSON.stringify ( data ) );

            component.setState({
                QCF : [1,2,3,4,5,6,7,8],
                SCQF : [1,2,3,4,5,6,7,8,9,10,11,12]
            }, function(){
                component.filter();
            });

        }

        else if ( 'SCQF' in filtered ) {

            var array = [];

            for ( var x = 0; x < filtered.SCQF.length; x++ ) {
                array.push(filtered.SCQF[x].id);
            }

            var data = {
                filterText: component.state.filterText,
                QCF : component.state.QCF,
                SCQF : array
            };

            localStorage.setItem('subjectFilter', JSON.stringify ( data ) );

            component.setState({
                SCQF : array
            }, function(){
                component.filter();
            });

        }

        else if ( 'QCF' in filtered ) {

            var array = [];

            for ( var x = 0; x < filtered.QCF.length; x++ ) {
                array.push(filtered.QCF[x].id);
            }

            var data = {
                filterText: component.state.filterText,
                QCF : array,
                SCQF : component.state.SCQF
            };

            localStorage.setItem('subjectFilter', JSON.stringify ( data ) );

            component.setState({
                QCF : array
            }, function(){
                component.filter();
            });

        }

    },

    filter: function() {

        var component = this;
        var filterText = this.state.filterText;
        var filterSCQF = this.state.SCQF;
        var filterQCF = this.state.QCF;

        if ( filterText == 'maths' ) {
            var modFilterText = 'math';
        }
        else {
            var modFilterText = filterText;
        }

        var superclasses = 0;
        var count = 0;

        //console.log('filtering');
        var data = this.state.data;
        //console.log(data);
        var filteredData = [{"letter":"A","items":[]},{"letter":"B","items":[]},{"letter":"C","items":[]},{"letter":"D","items":[]},{"letter":"E","items":[]},{"letter":"F","items":[]},{"letter":"G","items":[]},{"letter":"H","items":[]},{"letter":"I","items":[]},{"letter":"J","items":[]},{"letter":"K","items":[]},{"letter":"L","items":[]},{"letter":"M","items":[]},{"letter":"N","items":[]},{"letter":"O","items":[]},{"letter":"P","items":[]},{"letter":"Q","items":[]},{"letter":"R","items":[]},{"letter":"S","items":[]},{"letter":"T","items":[]},{"letter":"U","items":[]},{"letter":"V","items":[]},{"letter":"W","items":[]},{"letter":"X","items":[]},{"letter":"Y","items":[]},{"letter":"Z","items":[]}];

        // loop over the 26 letters
        for ( var w = 0; w < data.length; w++) {

            // check if the letter has items
            if ( data[w].items.length > 0 ) {

                // loop over items
                for ( var x = 0; x < data[w].items.length; x++ ) {

                    // prepare superclass with no qualifications
                    var matchedQualifications = {
                        id: data[w].items[x].id,
                        title: data[w].items[x].title,
                        qualifications: []
                    };

                    var haystack = data[w].items[x].title.toLowerCase();
                    var needle = modFilterText.toLowerCase();

                    // check if input matches superclass title
                    if ( haystack.indexOf(needle) > -1 ) {

                        // loop over qualifications
                        for ( var y = 0; y < data[w].items[x].qualifications.length; y++) {

                            var subjects = [];

                            // loop over subjects
                            for ( var z = 0; z < data[w].items[x].qualifications[y].subjects.length; z++) {

                                var scqfHaystack = data[w].items[x].qualifications[y].subjects[z].scqf;
                                var qcfHaystack = data[w].items[x].qualifications[y].subjects[z].qcf;

                                var include = true;

                                // loop over scqf filter to check if subject needs to be excluded
                                for ( var a = 0; a < filterSCQF.length; a++ ) {

                                    if ( scqfHaystack.indexOf( filterSCQF[a] ) > -1 ) { include = false; }

                                }

                                // loop over qcf filter to check if subject needs to be excluded
                                for ( var b = 0; b < filterQCF.length; b++ ) {

                                    if ( qcfHaystack.indexOf( filterQCF[b] ) > -1 ) { include = false; }

                                }

                                // if include is still true, include subject
                                if ( include == true ) {
                                    subjects.push( data[w].items[x].qualifications[y].subjects[z] );
                                }

                            }

                            // push qualification into superclass if it has subjects
                            if ( subjects.length > 0 ) {

                                superclasses = superclasses + 1;
                                count = count + subjects.length;

                                matchedQualifications.qualifications.push({
                                    "qualification" : data[w].items[x].qualifications[y].qualification,
                                    "subjects" : subjects
                                })

                            }

                        }

                    }

                    else {

                        // loop over qualifications
                        for ( var y = 0; y < data[w].items[x].qualifications.length; y++) {

                            var subjects = [];

                            // loop over subjects
                            for ( var z = 0; z < data[w].items[x].qualifications[y].subjects.length; z++) {

                                var subjectHaystack = data[w].items[x].qualifications[y].subjects[z].title.toLowerCase();

                                // check if text input is matched against subject title
                                if ( subjectHaystack.indexOf(needle) > -1 ) {

                                    console.log('---');
                                    console.log(needle);
                                    console.log(subjectHaystack);

                                    var scqfHaystack = data[w].items[x].qualifications[y].subjects[z].scqf;
                                    var qcfHaystack = data[w].items[x].qualifications[y].subjects[z].qcf;

                                    var include = true;

                                    // loop over scqf filter to check if subject needs to be excluded
                                    for (var a = 0; a < filterSCQF.length; a++) {

                                        if (scqfHaystack.indexOf(filterSCQF[a]) > -1) {
                                            include = false;
                                        }

                                    }

                                    // loop over qcf filter to check if subject needs to be excluded
                                    for (var b = 0; b < filterQCF.length; b++) {

                                        if (qcfHaystack.indexOf(filterQCF[b]) > -1) {
                                            include = false;
                                        }

                                    }

                                    // if include is still true, include subject
                                    if (include == true) {
                                        console.log(data[w].items[x].qualifications[y].subjects[z].title);
                                        subjects.push(data[w].items[x].qualifications[y].subjects[z]);
                                    }

                                }

                            }

                            // push qualification into superclass if it has subjects
                            if ( subjects.length > 0 ) {

                                superclasses = superclasses + 1;
                                count = count + subjects.length;

                                matchedQualifications.qualifications.push({
                                    "qualification" : data[w].items[x].qualifications[y].qualification,
                                    "subjects" : subjects
                                })

                            }

                        }

                    }

                    if ( matchedQualifications.qualifications.length > 0 ) {
                        //console.log(matchedQualifications);
                        filteredData[w].items.push( matchedQualifications );
                    }

                };

            }

        }

        this.setState({
            filteredData : filteredData,
            count: count,
            superclasses: superclasses,
            filterText: filterText
        });
    },

});

if ( document.getElementById('app') ) {

    var app = ReactDOM.render(
        <App />,
        document.getElementById('app')
    );

}

// hot module replacement
// full refresh if required
// module.hot.accept();




/** WEBPACK FOOTER **
 ** ./app/index.jsx
 **/